import {
  FeatureDisplayCards,
  HeroSection,
  LandingHeader,
  PricingSlider,
  TrustSparkles,
} from '@/features/marketing';

export default function FleetLandingPage() {
  return (
    <div className="relative isolate flex min-h-screen flex-col bg-default text-strong">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-screen bg-[radial-gradient(ellipse_at_100%_0%,var(--tw-gradient-stops))] from-accent-blue/20 via-accent-sky/10 via-25% to-transparent to-65%"
      />
      <LandingHeader />
      <main>
        <HeroSection />
        <section className="relative py-12 md:py-16">
          <div className="mx-auto grid max-w-7xl items-center gap-12 px-6 lg:grid-cols-2 lg:gap-16">
            <FeatureDisplayCards />
            <TrustSparkles />
          </div>
        </section>
        <div id="prezzi" className="py-12 md:py-16">
          <PricingSlider />
        </div>
      </main>
    </div>
  );
}
